import {getPreference} from '@netx/core-user-next/utils';
import {FacialRecognitionPref} from '../constants';

export const faceRecognitionEnabled = () =>
	getPreference<true>(FacialRecognitionPref.ENABLED, true);
